import React, { Component } from 'react'

import { getTransportVictoriaPage } from '../../../services/reservoir'

import Loading from '../Loading';
import parse from 'html-react-parser';
import { formatDate } from '../../../actions/dateUtility'

import { vuHQLink } from '../../../helpers/links'

class PublicTransportVictoriaReport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:true, 
      useDrupalTV: false,
      drupalTV: []
    }
  }

  componentDidMount() {
    getTransportVictoriaPage(formatDate(new Date(), 'yyyy-MM-dd')).then(tvPage => {
      this.setState({
        loading: false,
        useDrupalTV: tvPage && tvPage && tvPage.length > 0 && tvPage[0].attributes && tvPage[0].attributes.body && tvPage[0].attributes.body.value,
        drupalTV: tvPage[0].attributes,
      })
    })
  }

  handleFormSubmit = event => {
    this.props.submit(event)
  }

  handleFormCancel = event => {
    this.props.cancel(event)
  }

  renderDrupalTransportVictoria = () => {
    if (this.state.useDrupalTV) {
      return (
        <div>
          {parse(this.state.drupalTV.body.value)}
        </div>
        )
    }
  }

  renderDrupalTransportVictoriaHeader = () => {
    if (this.state.useDrupalTV) {
      return (
        <div className={'reports-page-heading'}>
          {parse(this.state.drupalTV.field_header.value)}
        </div>
      )
    }
  }

  render() {

    if (this.state.loading) {
      <Loading />
    }

    return (
      <div>
        
        {this.renderDrupalTransportVictoriaHeader()}

        {this.renderDrupalTransportVictoria()}

        <div className={'ptv-request-details'}>
          <div className="row">
            <div className={'col-xs-12 col-md-2 col-lg-1 column-1'}>Form Year</div>
            <div className={'col-lg'}>{this.props.year}</div>
          </div>
          <div className="row">
            <div className={'col-xs-12 col-md-2 col-lg-1 column-1'}>Student Id</div>
            <div className={'col-lg'}>{this.props.personalDetails.studentId}</div>
          </div>
          <div className="row">
            <div className={'col-xs-12 col-md-2 col-lg-1 column-1'}>Given Name</div>
            <div className={'col-lg'}>{this.props.personalDetails.legalFirstName}</div>
          </div>
          <div className="row">
            <div className={'col-xs-12 col-md-2 col-lg-1 column-1'}>Surname</div>
            <div className={'col-lg'}>{this.props.personalDetails.legalLastName}</div>
          </div>
          {/*<div className="row">*/}
          {/*  <div className={'col-xs-12 col-md-2 col-lg-1 column-1'}>Email</div>*/}
          {/*  <div className={'col-lg'}>{this.props.personalDetails.contactPersonalEmail}</div>*/}
          {/*</div>*/}
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-3">
            <button disabled={this.props.submitting} className="btn btn-lg btn-primary" onClick={event => this.handleFormSubmit(event)}>
              Submit my request
            </button>
          </div>
          <div className="col-xs-12 col-md-3">
            <button disabled={this.props.submitting} className="btn btn-lg btn-secondary" onClick={event => this.handleFormCancel(event)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default PublicTransportVictoriaReport
